import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';

import ModalPortal from '../../../../../components/modal-portal';

import messages from '../../../messages';
import style from './style.module.less';

const DeactivateProductModal = ({ onClose, onConfirm }) => {
  return (
    <ModalPortal onClose={onClose}>
      <Modal className={style['confirmation-modal']} size='small'>
        <ModalHeader closeModal={onClose}>
          <FormattedMessage {...messages.deactivateModalTitle} />
        </ModalHeader>
        <ModalBody className={style['confirmation-modal-body']}>
          <FormattedMessage {...messages.deactivateProductWarning} />
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} theme='tertiary'>
            <FormattedMessage {...messages.cancel} />
          </Button>
          <Button onClick={onConfirm} theme='primary'>
            <div className={style['combine-button']}>
              <FormattedMessage {...messages.confirm} />
            </div>
          </Button>
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

DeactivateProductModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default DeactivateProductModal;
